import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massForceDeleteAirports } from "../../api/apiAirports";
import parseError from "../../utils/parseError";

const useForceDeleteAllAirports = () => {
    const queryClient = useQueryClient();

    const { mutate: forceDeleteAllAirports, isPending } = useMutation({
        mutationFn: massForceDeleteAirports,
        onSuccess: (res) => {
            const message = res?.message || "Airports deleted permanently";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["airports"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to permanently delete airports");
        },
    });

    return { forceDeleteAllAirports, isForceDeleteAll: isPending };
};

export default useForceDeleteAllAirports;
